export default __webpack_public_path__ + "static/image-45-1--5c3c5e7c75815009df9a5d7df5ee2373.png";